import axios from 'axios';
import { LOADING_USER_PROFILE, LOADED_USER_PROFILE, NOT_LOGGED_IN } from './user.types';
import { loadAllCompletedTopics, loadCompletedCourses } from '../courses';
const dropboxNewRestEndpoint = process.env.DROPBOX_NEW_REST_ENDPOINT;

// eslint-disable-next-line import/prefer-default-export
export const loadUserProfile = (localStorageValue) => {
  return async (dispatch) => {
    try {
      // Restrict API call if user agent contains 'coveobot'
      if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().includes('coveobot')) {
        dispatch({
          type: NOT_LOGGED_IN
        });
        return;
      }
      if (localStorageValue !== "true") {
        dispatch({
          type: NOT_LOGGED_IN
        });
        return;
      }

      dispatch({
        type: LOADING_USER_PROFILE
      });

      const response = await axios({
        method: 'post',
        url: `${dropboxNewRestEndpoint}/get_user_profile`,
        data: {},
        withCredentials: true
      });

      const {
        // eslint-disable-next-line camelcase
        data: { first_name, last_initial, user_xid }
      } = response;
      dispatch({
        type: LOADED_USER_PROFILE,
        payload: {
          id: user_xid,
          firstName: first_name,
          lastInitial: last_initial
        }
      });
      dispatch(loadCompletedCourses());
      dispatch(loadAllCompletedTopics());


    } catch (error) {
      dispatch({
        type: NOT_LOGGED_IN
      });
    }
  };
};
